import { appUrl } from "@astro/config"
import { CourseCard, CourseCardSkeleton, decorateCourse } from "@astro/course-card"
import { useCourses } from "../../hooks/useCourses"

export default function AcademySection() {
  const { courses: apiCourses, isPending } = useCourses(3)
  const courses = apiCourses.map((c, i) => decorateCourse(c, i))

  return (
    <section className="relative overflow-hidden pb-20 md:px-18 bg-white text-gray-800 font-normal select-none">
      <div className="pointer-events-none absolute inset-0 opacity-[0.65] -z-10">
        <div className="absolute -right-24 top-10 h-96 w-96 rounded-full bg-[radial-gradient(circle,rgba(232,119,15,0.12)_0%,transparent_70%)] blur-3xl animate-pulse"></div>
        <div className="absolute -left-24 bottom-0 h-96 w-96 rounded-full bg-[radial-gradient(circle,rgba(123,13,30,0.08)_0%,transparent_70%)] blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="container relative z-10 mx-auto px-6 max-w-350">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 space-y-8">
            <div className="space-y-4 text-left">
              <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gray-50 border border-primary/10 shadow-sm text-secondary text-lg"><i className="fa-solid fa-graduation-cap animate-pulse"></i></div>
                <div className="space-y-0.5">
                  <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-primary/40">VEDIC ACADEMY</p>
                  <h2 className="text-2xl md:text-4xl font-light text-primary leading-tight uppercase tracking-tight font-heading">Learn the <span className="font-bold text-secondary block sm:inline">Sacred Science</span></h2>
                </div>
              </div>
              <div className="w-16 h-0.5 bg-secondary my-4"></div>
              <p className="max-w-md text-sm md:text-base text-primary/60 font-body leading-relaxed normal-case">Master Vedic astrology, numerology and palmistry through certified courses and live masterclasses — guided personally by Raju Maharaj Ji.</p>
            </div>

            <div className="flex flex-col gap-2.5 pt-1 text-[10px] font-bold uppercase tracking-widest text-primary/60">
              <div className="flex items-center gap-3 px-4 py-2 bg-gray-50 rounded-xl shadow-sm border border-gray-100/60"><i className="fa-solid fa-award text-secondary text-xs"></i> Certified courses</div>
              <div className="flex items-center gap-3 px-4 py-2 bg-gray-50 rounded-xl shadow-sm border border-gray-100/60"><i className="fa-solid fa-video text-secondary text-xs"></i> Live + recorded sessions</div>
              <div className="flex items-center gap-3 px-4 py-2 bg-gray-50 rounded-xl shadow-sm border border-gray-100/60"><i className="fa-solid fa-shield-halved text-secondary text-xs"></i> Expert mentorship structure</div>
            </div>

            <div className="flex flex-wrap items-center gap-x-4 gap-y-3 pt-2">
              <a
                href={appUrl("education")}
                className="inline-flex items-center justify-center whitespace-nowrap bg-primary hover:bg-secondary text-white font-semibold px-8 h-12 rounded-2xl text-[10px] tracking-widest uppercase shadow-lg shadow-primary/10 transition-all duration-300"
              >
                Explore Academy <i className="fa-solid fa-arrow-right ml-2 text-xs"></i>
              </a>
              <a
                href={appUrl("education", "classes")}
                className="group inline-flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-primary/60 transition-colors hover:text-secondary"
              >
                Book a free demo <i className="fa-solid fa-chevron-right text-[9px] transition-transform group-hover:translate-x-1"></i>
              </a>
            </div>
          </div>

          {(isPending || courses.length > 0) && (
            <div className="lg:col-span-7 relative">
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 relative z-10">
                {isPending
                  ? Array.from({ length: 3 }, (_, i) => <CourseCardSkeleton key={i} />)
                  : courses.map((course) => (
                      <CourseCard
                        key={course.id}
                        course={course}
                        href={appUrl('education', `classes/${course.slug ?? course.id}`)}
                      />
                    ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
